export const API_BASE_URL = process.env.REACT_APP_REMOTE_API_URL || 'http://localhost:3000';
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY; 

export const getApiBaseUrl = (): string => {
  const useRemoteApi = localStorage.getItem('useRemoteApi') === 'true';
  return useRemoteApi 
    ? (process.env.REACT_APP_REMOTE_API_URL || 'http://localhost:3000')
    : (process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:3000');
}; 